(() => {
  if (window.tblJourneyBoot) { window.tblJourneyBoot(); return; }
  const boot = () => {
    document.querySelectorAll('[data-product-journey]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const main = document.querySelector('[data-modular-home]');
      const premium = document.querySelector('[data-sweaty-yeti-configurator], .rqc');
      const options = main?.querySelector('[data-state]')?.closest('.mh-step') || premium || document.querySelector('product-variant-selects') || document.querySelector('.product-form__buttons');
      const enquiry = main?.querySelector('[data-modular-inquiry]') || premium?.querySelector('form[action*="/contact"]');
      const targets = { options, suitability: document.querySelector('[data-product-suitability]'), guidance: document.querySelector('[data-product-guidance]'), faqs: document.querySelector('[data-product-faqs]'), proof: document.querySelector('[data-product-proof]'), enquiry };
      root.querySelectorAll('[data-journey-target]').forEach(link => {
        const key = link.dataset.journeyTarget;
        const target = targets[key];
        if (!target) { link.hidden = true; return; }
        if (!target.id) target.id = 'ProductJourney-' + key + '-' + root.closest('.shopify-section').id;
        link.href = '#' + target.id;
        link.hidden = false;
      });
      const moveTo = target => {
        if (!target) return;
        target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
        const field = target.matches('input, select, button') ? target : target.querySelector('select, input:not([type="hidden"]), button');
        field?.focus({preventScroll:true});
      };
      const bar = root.querySelector('[data-journey-mobile]');
      if (main || premium) {
        root.querySelector('[data-journey-configure]').addEventListener('click', () => moveTo(options));
        const enquireButton = root.querySelector('[data-journey-enquire]');
        enquireButton.hidden = !enquiry;
        enquireButton.addEventListener('click', () => {
          const existing = main?.querySelector('[data-enquire]');
          if (existing) existing.click();
          moveTo(enquiry);
        });
        let queued = false;
        const updateBar = () => {
          queued = false;
          const inView = target => {
            if (!target) return false;
            const rect = target.getBoundingClientRect();
            return rect.bottom > 0 && rect.top < window.innerHeight;
          };
          const drawerOpen = document.body.classList.contains('drawer--is-open') || document.querySelector('dialog[open]');
          const pastOptions = options && options.getBoundingClientRect().bottom < 0;
          bar.hidden = !pastOptions || inView(enquiry) || !!drawerOpen;
        };
        const queueUpdate = () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(updateBar);
        };
        const observer = new IntersectionObserver(updateBar, {threshold:0});
        if (options) observer.observe(options);
        if (enquiry) observer.observe(enquiry);
        window.addEventListener('scroll', queueUpdate, {passive:true});
        window.addEventListener('resize', queueUpdate);
        updateBar();
        const unload = event => {
          if (!event.target.contains(root)) return;
          observer.disconnect();
          window.removeEventListener('scroll', queueUpdate);
          window.removeEventListener('resize', queueUpdate);
          document.removeEventListener('shopify:section:unload', unload);
        };
        document.addEventListener('shopify:section:unload', unload);
      }
    });
  };
  window.tblJourneyBoot = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
